<template>
  <div class="container mt-4">
    <div v-if="trackingData.length > 0">
      <h4 class="mb-3">
        <i class="bi bi-clock-history me-2"></i> Historial de movimientos
      </h4>
      <ul class="list-group">
        <li v-for="(item, index) in trackingData" :key="item.id"
          class="list-group-item d-flex justify-content-between align-items-start">
          <div class="ms-2 me-auto">
            <div class="fw-bold">
              <i class="bi bi-truck me-2 text-primary"></i>
              {{ item.descripcion }}
            </div>
            <small class="text-muted">
              <i class="bi bi-calendar-event me-1"></i>
              {{ formatDateToCustomString(item.created_at) }}
            </small>
          </div>
          <span class="badge bg-secondary rounded-pill">#{{ index + 1 }}</span>
        </li>
      </ul>
    </div>

    <div v-else class="alert alert-warning mt-3" role="alert">
      <i class="bi bi-exclamation-circle me-2"></i>
      {{ error != "" && error != null ? error : "No hay información disponible" }}
    </div>
  </div>
</template>

<script>
import { formatDateToCustomString } from "../utils/dateUtils";
export default {
  name: "TrackingTable",
  props: {
    trackingData: {
      type: Array,
      required: true,
    },
    trackingCode: {
      type: String,
      required: true,
    },
    error: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    formatDateToCustomString,
  },
};
</script>

<style scoped>
/* Estilos personalizados opcionales */
</style>
